export default {
  fetchLoggedUser: "/users/me",
  userAcceptCookies: "/users/{id}/cookies/",
  userLang: "/users/{id}/lang/",
}
